// src/pages/FacturacionPresupuestos/catalogoInicialDatos.js
// Catálogo inicial con datos reales extraídos de los documentos oficiales:
// - Presupuesto Azua Folio 031
// - Presupuesto Paseos de la Venta Folio 029
// - Nota de Pago Fiorelo Folio 005
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { PLANTILLAS_BASE } from '../../utils/plantillasDocumentos';

export const CLIENTES_INICIALES_REFERENCIA = [
    {
        id: 'cli_azua_avr031',
        nombre: 'Fraccionamiento Azua, Villa Real',
        rfc: 'FAV-180420-9B2',
        contacto: 'C. Ricardo Cruz (Administrador)',
        telefono: '442-190-8451',
        email: 'administracion@azuavillareal.mx',
        direccion: 'Av. Villa Real S/N, San Pedro Ahuacatlán',
        municipioEstado: 'San Juan del Río, Qro., C.P. 76810',
        notas: 'Padrón residencial de 110 viviendas. Proyecto de control de acceso perimetral automatizado (Folio PF-2026-AVR-031).',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'cli_paseos_cpv029',
        nombre: 'Administradora de Condominios Opsa SA de CV',
        rfc: 'ACO-190815-7X1',
        contacto: 'Sr. Omar Pacheco Ruiz (Administrador)',
        telefono: '427-114-8920',
        email: 'condominios.opsa@gmail.com',
        direccion: 'Condominio Paseos de la Venta, Acceso Principal',
        municipioEstado: 'San Juan del Río, Qro., C.P. 76800',
        notas: '150 unidades habitacionales y 1 caseta. Licenciamiento anual y puesta en marcha de plataforma SaaS (Folio PF-2026-CPV-029).',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'cli_fiorelo_fio005',
        nombre: 'Fraccionamiento Fiorelo Qro.',
        rfc: 'FFQ-210310-8A4',
        contacto: 'Christian Adrián Hernández Ponga (Presidente)',
        telefono: '442-325-7719',
        email: 'comite.fiorelo@gmail.com',
        direccion: 'Fraccionamiento Fiorelo, Caseta de Vigilancia',
        municipioEstado: 'Santiago de Querétaro, Qro., C.P. 76116',
        notas: 'Comunidad de 78 viviendas. Periodo de evaluación demo SaaS y formalización anual (Folio NP-2026-FIO-DEMO-005).',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'cli_claustros_santafe',
        nombre: 'Condominio Claustros de Santa Fe 4',
        rfc: 'CSF-170601-5L8',
        contacto: 'Comité de Administración y Vigilancia',
        telefono: '414-226-3804',
        email: 'admin.claustros4@domushabita.mx',
        direccion: 'Tablajeros la Calera S/N, Col. Santa Fe',
        municipioEstado: 'Tequisquiapan, Qro., C.P. 76750',
        notas: 'Fraccionamiento residencial con control vehicular HikVision y app activa.',
        actualizadoEn: new Date().toISOString()
    }
];

export const CONCEPTOS_INICIALES_REFERENCIA = [
    {
        id: 'conc_hw_acceso_azua',
        nombre: 'Suministro de Hardware y Dispositivos de Control de Acceso Perimetral',
        descripcion: 'Equipamiento industrial: 1 Controlador maestro 4 puertas, 2 antenas UHF largo alcance (10-20m) IP66, 2 lectores QR/tarjetas, 150 tags RFID parabrisas, 2 pedestales tubulares, 2 fotoceldas y cableado UTP Cat5e con canalización.',
        unidad: 'Lote',
        precioUnitario: 26186.04,
        categoria: 'Hardware y Equipamiento',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'conc_mo_instalacion_azua',
        nombre: 'Ingeniería de Instalación, Conexión, Calibración y Puesta en Marcha (4 Días Hábiles)',
        descripcion: 'Mano de obra calificada (33%): Montaje de pedestales, canalización subterránea, cableado blindado, vinculación a barreras vehiculares, calibración de radiofrecuencia para apertura fluida, carga de padrón y capacitación.',
        unidad: 'Servicio',
        precioUnitario: 8641.39,
        categoria: 'Mano de Obra',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'conc_anualidad_sistemas_azua',
        nombre: 'Anualidad Integral de Sistemas: Plataforma SaaS Cloud + Servidor Local + Respaldo UPS (2.5h)',
        descripcion: '12 Meses de servicio completo pagando únicamente 10 meses (2 meses de renta bonificados 100% de cortesía). Incluye web, app móvil +999 dispositivos, pases QR y desactivación de tags a morosos.',
        unidad: 'Mes',
        precioUnitario: 3400.00,
        categoria: 'SaaS y Software',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'conc_poliza_saas_paseos',
        nombre: 'Licenciamiento Anual y Puesta en Marcha de Plataforma SaaS «Domus Habita» con Control de Acceso Completo',
        descripcion: 'Servicio en la nube para administración, seguridad perimetral y cobranza de 150 viviendas. Tarifa preferencial congelada de $2,400.00 MXN/mes. Incluye módulo de desactivación automática de tags RFID a morosos.',
        unidad: 'Mes',
        precioUnitario: 2400.00,
        categoria: 'SaaS y Software',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'conc_continuidad_esencial_fiorelo',
        nombre: 'Propuesta Continuidad Esencial Plataforma Web y Móvil (78 Viviendas)',
        descripcion: 'Panel web multi-rol (2 admins), app Android caseta y residentes, web iOS, registro de paquetería, pases QR dinámicos, finanzas con corte diario, amenidades y soporte continuo L-V.',
        unidad: 'Mes',
        precioUnitario: 1400.00,
        categoria: 'SaaS y Software',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'conc_demo_evaluacion_fiorelo',
        nombre: 'Licenciamiento Mensual de Demostración y Evaluación SaaS',
        descripcion: 'Mes de evaluación demo de infraestructura en la nube, soporte técnico y plataforma multi-dispositivo acordada con el comité.',
        unidad: 'Mes',
        precioUnitario: 722.00,
        categoria: 'SaaS y Software',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'conc_tag_rfid_parabrisas',
        nombre: 'Tag RFID Adhesivo para Parabrisas de Alta Frecuencia UHF (902-928 MHz)',
        descripcion: 'Tag vehicular de alta durabilidad con chip anti-desprendimiento y lectura de largo alcance (hasta 15 metros). Incluye codificación y alta en base de datos.',
        unidad: 'Pieza',
        precioUnitario: 45.00,
        categoria: 'Consumibles y Accesorios',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'conc_controlador_hikvision_4p',
        nombre: 'Controlador Maestro de Accesos HikVision 4 Puertas / TCP-IP',
        descripcion: 'Controlador de grado profesional para 4 accesos vehiculares o peatonales con comunicación de red, gabinete metálico cerrado y fuente de poder regulada 12V / 8A.',
        unidad: 'Pieza',
        precioUnitario: 8500.00,
        categoria: 'Hardware y Equipamiento',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'conc_antena_uhf_largo_alcance',
        nombre: 'Antena Lectora UHF de Largo Alcance (10 a 20 Metros) IP66',
        descripcion: 'Antena direccional de polarización circular para lectura rápida de tags sin necesidad de bajar la ventanilla. Carcasa impermeable para intemperie.',
        unidad: 'Pieza',
        precioUnitario: 7200.00,
        categoria: 'Hardware y Equipamiento',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'conc_lector_qr_tarjeta_caseta',
        nombre: 'Lector Dual de Códigos QR y Tarjetas Digitales para Caseta de Vigilancia',
        descripcion: 'Dispositivo óptico ultra-rápido para escaneo de códigos QR de visitas y credenciales NFC/Mifare en caseta. Conexión USB/RS485 y feedback sonoro.',
        unidad: 'Pieza',
        precioUnitario: 3800.00,
        categoria: 'Hardware y Equipamiento',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'conc_pedestal_tubular_metalico',
        nombre: 'Pedestal Tubular Metálico de Uso Rudo para Antena Vehicular',
        descripcion: 'Fabricado en acero con acabado anticorrosivo y pintura electrostática horneada. Placa de anclaje con 4 taquetes de expansión de 1/2 pulgada.',
        unidad: 'Pieza',
        precioUnitario: 1850.00,
        categoria: 'Hardware y Equipamiento',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'conc_fotoceldas_seguridad_10m',
        nombre: 'Par de Fotoceldas Infrarrojas de Seguridad Anti-aplastamiento (10m)',
        descripcion: 'Sensor de haz infrarrojo sincronizado emisor/receptor para evitar el cierre accidental de brazos de barrera vehicular mientras cruzan vehículos o personas.',
        unidad: 'Par',
        precioUnitario: 950.00,
        categoria: 'Hardware y Equipamiento',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'conc_cableado_utp_cat5e',
        nombre: 'Bobina de Cable UTP Cat5e Blindado para Exterior y Canalización',
        descripcion: 'Bobina de 305 metros 100% cobre con doble chaqueta para intemperie, conectores RJ45 apantallados, tubería conduit y cajas de registro herméticas IP55.',
        unidad: 'Lote',
        precioUnitario: 3200.00,
        categoria: 'Materiales e Instalación',
        actualizadoEn: new Date().toISOString()
    }
];

export const PROVEEDORES_INICIALES_REFERENCIA = [
    {
        id: 'prov_autotecsol',
        nombre: 'Autotecsol / Automatización y Control Electrónico',
        rfc: 'AUT-160510-1T2',
        contacto: 'Ing. Armando Rodríguez',
        telefono: '442-215-6033',
        email: 'ventas@autotecsol.com.mx',
        direccion: 'Parque Industrial Benito Juárez, Nave 4',
        municipioEstado: 'Santiago de Querétaro, Qro.',
        categoria: 'Automatización Vehicular y Barreras',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'prov_hikvision_mx',
        nombre: 'HikVision México / Distribución Mayorista CCTV',
        rfc: 'HIK-120418-8U9',
        contacto: 'Departamento de Soporte y Proyectos',
        telefono: '55-5208-8888',
        email: 'soporte.mexico@hikvision.com',
        direccion: 'Insurgentes Sur #1602, Crédito Constructor',
        municipioEstado: 'Ciudad de México, CDMX',
        categoria: 'Control de Acceso y Cámaras LPR',
        actualizadoEn: new Date().toISOString()
    },
    {
        id: 'prov_syscom',
        nombre: 'SYSCOM México / Redes y Telecomunicaciones',
        rfc: 'SYS-850912-3K1',
        contacto: 'Asesor Comercial de Sucursal Querétaro',
        telefono: '442-238-1200',
        email: 'ventas.queretaro@syscom.mx',
        direccion: 'Av. 5 de Febrero #1325, San Pablo',
        municipioEstado: 'Santiago de Querétaro, Qro.',
        categoria: 'Redes, Cableado UTP y Fuentes de Poder',
        actualizadoEn: new Date().toISOString()
    }
];

export const NOTAS_CLAVE_PRESETS = [
    {
        id: 'nota_csf4_finiquito_pago',
        titulo: 'Constancia de Finiquito y No Adeudo (Claustros de Santa Fe 4 Folio 003)',
        tipo: 'pago',
        texto: '• Vínculo Contractual y Finiquito Definitivo: Este comprobante ampara el pago total y definitivo acordado en la Cláusula 8 y Tabla 2 del Contrato de Prestación de Servicios Digitales SaaS Folio 3 celebrado en San Juan del Río, Qro.\n• Saldo en Cero: No genera adeudos acumulados ni saldos insolutos para el periodo anual contratado, extendiéndose el más amplio finiquito que en derecho proceda.\n• Validez: Ampara la operatividad del sistema para 44 domicilios, app móvil, panel de administración y caseta sin costos adicionales durante la vigencia amparada.'
    },
    {
        id: 'nota_fiorelo_finiquito_demo',
        titulo: 'Finiquito Periodo Demo y Liquidación Preferencial (Fiorelo Folio 005)',
        tipo: 'remision',
        texto: '• Finiquito de Evaluación Demo: Este estado de cuenta ampara en su totalidad el cierre del periodo acordado del 24 de julio al 27 de septiembre de 2026. Admite pago en efectivo o transferencia electrónica.\n• Saldo Saldado: Una vez cubierto, el fraccionamiento no conserva ningún pasivo pendiente por este concepto.\n• Cortesía Comercial Domus Habita: Se bonifican 2 meses completos de renta ($1,444.00 MXN) en agradecimiento a la preferencia de Fiorelo.\n• Precios más I.V.A. en caso de requerir factura con CFDI.'
    },
    {
        id: 'nota_remision_servicios_devengados',
        titulo: 'Condiciones de Cobro por Servicios Concluidos (Remisión Estándar)',
        tipo: 'remision',
        texto: '• Servicios Concluidos a Satisfacción: El presente documento ampara los servicios y suministros debidamente entregados y verificados.\n• Fecha Límite de Liquidación: Favor de cubrir el saldo dentro de los 5 días hábiles posteriores a su emisión para garantizar la continuidad operativa sin interrupciones.\n• Comprobante de Pago: Al efectuar su transferencia, favor de remitir el comprobante bancario vía WhatsApp o correo electrónico para la emisión inmediata de su recibo o CFDI correspondiente.'
    },
    {
        id: 'nota_azua_llave_en_mano',
        titulo: 'Condición Llave en Mano con Anualidad Bonificada (Azua Folio 30/31)',
        tipo: 'presupuesto',
        texto: '• Esquema Llave en Mano Integral: Anticipo del 60% ($20,896.46 MXN) para pedidos y arranque; saldo del 40% ($13,930.97 MXN) contra entrega y puesta en marcha en 4 días hábiles.\n• Ahorro Directo Garantizado: Al cubrir la anualidad recibe 2 meses de servicio y renta 100% gratis frente a pagos mensuales.\n• Cero Preocupación Mensual: El fraccionamiento queda cubierto por 12 meses sin cuotas recurrentes mes con mes. Precios netos antes de impuestos (IVA 16% en caso de factura con CFDI).'
    },
    {
        id: 'nota_paseos_politica_mora',
        titulo: 'Términos Contractuales y Blindaje Antimorosidad (Paseos de la Venta)',
        tipo: 'presupuesto',
        texto: '• Esquema de Cobro: Pago mensual recurrente con corte al día 28 de cada mes más 3 días naturales de gracia.\n• Política de Suspensión y Reconexión: Suspensión automática del servicio al vencimiento sin prórroga. Cuota de reconexión del 2.5% sobre saldo insoluto, reactivándose en un plazo máximo de 24 horas hábiles posteriores al reporte de pago.\n• Ventaja Exclusiva: Función estrella de desactivación de tags RFID para residentes morosos, erradicando cartera vencida y ahorrando hasta 70% de tiempo en cobranza.'
    },
    {
        id: 'nota_garantia_estandar',
        titulo: 'Garantía Estándar de Hardware y Soporte Permanente',
        tipo: 'presupuesto',
        texto: '• Garantía de 12 meses contra defectos de fábrica en todos los equipos suministrados.\n• Soporte técnico continuo de software de lunes a viernes de 09:00 a 18:00 hrs y guardias de fin de semana para emergencias de acceso.\n• Precios expresados en Pesos Mexicanos (MXN). Vigencia de cotización: 15 días naturales a partir de la fecha de expedición.'
    }
];

// Función para sembrar en Firestore
export const sembrarDatosInicialesPrueba = async (db) => {
    let agregadosClientes = 0;
    let agregadosConceptos = 0;
    let agregadosProveedores = 0;

    // 1. Clientes
    for (const c of CLIENTES_INICIALES_REFERENCIA) {
        await setDoc(doc(db, 'plataforma_facturacion_clientes', c.id), c, { merge: true });
        agregadosClientes++;
    }

    // 2. Conceptos
    for (const cp of CONCEPTOS_INICIALES_REFERENCIA) {
        await setDoc(doc(db, 'plataforma_facturacion_conceptos', cp.id), cp, { merge: true });
        agregadosConceptos++;
    }

    // 3. Proveedores
    for (const p of PROVEEDORES_INICIALES_REFERENCIA) {
        await setDoc(doc(db, 'plataforma_facturacion_proveedores', p.id), p, { merge: true });
        agregadosProveedores++;
    }

    return {
        clientes: agregadosClientes,
        conceptos: agregadosConceptos,
        proveedores: agregadosProveedores
    };
};

/**
 * Sincroniza y asegura la disponibilidad de los modelos oficiales de documentos
 * (Presupuesto, Remisión y Nota de Pago) directamente en Firebase Firestore.
 * Colección: plataforma_facturacion_modelos_oficiales
 * Documentos: 'presupuesto', 'remision', 'pago'
 */
export const sincronizarModelosOficialesFirestore = async (db, forzarResiembra = false) => {
    const tipos = ['presupuesto', 'remision', 'pago'];
    const resultado = {};

    for (const tipo of tipos) {
        try {
            const docRef = doc(db, 'plataforma_facturacion_modelos_oficiales', tipo);
            if (!forzarResiembra) {
                const snap = await getDoc(docRef).catch(() => null);
                if (snap && snap.exists()) {
                    resultado[tipo] = { id: tipo, ...snap.data() };
                    continue;
                }
            }
            // Si no existe o se solicita re-siembra, escribir la plantilla oficial base en Firestore
            const base = PLANTILLAS_BASE[tipo];
            if (base) {
                const datosParaFirestore = {
                    ...JSON.parse(JSON.stringify(base)),
                    id: tipo,
                    actualizadoEn: new Date().toISOString(),
                    origenModelo: 'Firebase Cloud Firestore'
                };
                await setDoc(docRef, datosParaFirestore, { merge: true });
                resultado[tipo] = datosParaFirestore;
            }
        } catch (err) {
            console.warn(`Aviso al sincronizar modelo oficial ${tipo} con Firestore:`, err);
            // Fallback a la plantilla local en memoria
            resultado[tipo] = PLANTILLAS_BASE[tipo];
        }
    }

    return resultado;
};
